import { gql } from '@apollo/client';
import { CompanyDetailsFragment } from './fragment';
export const companyDetails = gql `
  query CompanyDetails($id: UUID!) {
    company: company2(id: $id) {
      ...CompanyDetailsFragment @unmask
    }
    ${CompanyDetailsFragment}
  }
`;
